import styled from "@emotion/styled";
import { IconButton } from "@mui/material";

export const Container = styled.span<{ isMobile: boolean }>( ( { isMobile } ) => ( {
    marginRight: "10px",
    paddingLeft: isMobile ? "0px" : "20px",
} ) );

export const Button = styled( IconButton )( {
    borderRadius: "50%",
    padding: "8px",
    "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.2)",
    },
} );
